import React from 'react';
import { BottomNav } from './BottomNav';
import { IconName } from '../../primitives/Icon';


interface OrganizerBottomNavProps {
  activeTab: 'dashboard' | 'events' | 'profile';
  onTabChange: (tab: 'dashboard' | 'events' | 'profile') => void;
  className?: string;
  onProfileClick: () => void;
}

export const OrganizerBottomNav: React.FC<OrganizerBottomNavProps> = ({
  onTabChange,
  className,
  onProfileClick
}) => {
  const items = [
    {
      icon: 'BarChart' as IconName,
      label: 'Dashboard',
      onClick: () => onTabChange('dashboard')
    },
    {
      icon: 'Calendar' as IconName,
      label: 'Events',
      onClick: () => onTabChange('events')
    },
    {
      icon: 'User' as IconName,
      label: 'Profil',
      onClick: () => onTabChange('profile')
    },
    {
      icon: 'Menu' as IconName,
      label: 'Menu',
      type: 'menu' as const
    }
  ];

  return (
    <BottomNav 
      items={items}
      className={className}
      organizerMode={true}
      onBeforeDrawerOpen={() => {/* Si besoin */}}
      onProfileClick={onProfileClick}
    />
  );
}; 